<template>
  <div>
    <div>
      <v-card class="elevation-0" outlined>
        <v-tabs grow background-color="blue-grey lighten-5">
          <v-tab active-class="active" @click="selectTab('all')">
            <div class="tab-title">
              Tất cả
              <span class="tab-count">({{ statusCount.countAll }})</span>
            </div>
          </v-tab>
          <v-tab active-class="active" @click="selectTab('noContact')">
            <div class="tab-title">
              Chưa chăm sóc
              <span class="tab-count">({{ statusCount.countNoContact }})</span>
            </div>
          </v-tab>
          <v-tab active-class="active" @click="selectTab('appointmentSet')">
            <div class="tab-title">
              Đã đặt lịch hẹn
              <span class="tab-count">({{ statusCount.countAppointmentSet }})</span>
            </div>
          </v-tab>
          <v-tab active-class="active" @click="selectTab('productVerified')">
            <div class="tab-title">
              Đã tư vấn
              <span class="tab-count">({{ statusCount.countProductVerified }})</span>
            </div>
          </v-tab>
          <v-tab active-class="active" @click="selectTab('succeed')">
            <div class="tab-title">
              Đã nhập học
              <span class="tab-count">({{ statusCount.countSucceed }})</span>
            </div>
          </v-tab>
          <v-tab active-class="active" @click="selectTab('failed')">
            <div class="tab-title">
              Thất bại
              <span class="tab-count">({{ statusCount.countFailed }})</span>
            </div>
          </v-tab>
        </v-tabs>
      </v-card>
      <v-card class="elevation-0" outlined>
        <v-card-text class="py-6 px-6">
          <div style="display: flex; justify-content: flex-end">
            <v-menu v-model="showColumnSelector" offset-x :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <v-btn outlined v-on="on" color="primary" style="margin-bottom: 24px"> Cấu hình bảng </v-btn>
              </template>

              <v-list class="scrollable-menu">
                <v-list-item v-for="(header, index) in headers.filter(h => !h.default)" :key="index">
                  <v-list-item-action>
                    <v-checkbox v-model="header.show"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>{{ header.text }}</v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <v-card class="elevation-0" outlined>
            <v-data-table
              item-key="id"
              :headers="visibleHeaders"
              :loading="loading"
              :items="Leads"
              :items-per-page="pagination.itemsPerPage"
              :page.sync="pagination.page"
              :server-items-length="pagination.totalItems"
              disable-sort
              :height="400"
              :footer-props="{ 'items-per-page-text': 'Số khách hàng một trang' }"
              v-bind="this.$attrs"
              fixed-header
              @pagination="updatePagination"
            >
              <template v-slot:[`item.data`]="{ item }">
                <lead-student-card
                  :student="{ name: item.studentName, school: item.studentSchool, dob: item.studentDob }"
                />
              </template>
              <template v-slot:[`item.info`]="{ item }">
                <div style="height: 100%">
                  <lead-info-card :item="item" />
                </div>
              </template>
              <template v-slot:[`item.create`]="{ item }">
                <div style="height: 100%">
                  <LeadCreateCard
                    :item="item"
                    class="primary--text"
                    style="cursor: pointer"
                    @click="() => $router.push(`/lead/${item.id}`)"
                  />
                </div>
              </template>

              <template v-slot:[`item.note`]="{ item }">
                <v-tooltip bottom max-width="300px">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="ellipsis-text max-width-description" v-bind="attrs" v-on="on">
                      {{ item.note }}
                    </div>
                  </template>
                  <span>{{ item.note }}</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.products`]="{ item }">
                <div>{{ formatProducts(item.products) }}</div>
              </template>
              <template v-slot:[`item.inCharge`]="{ item }">
                <div>{{ formatInCharge(item.inCharge) }}</div>
              </template>
              <template v-slot:[`item.appointmentDate`]="{ item }">
                {{ formatAppointmentDate(item.id) }}
              </template>
              <template v-slot:[`item.testDate`]="{ item }">
                {{ formatTestDate(item.testDate) }}
              </template>
              <template v-slot:[`item.status`]="{ item }">
                {{ formatLead(item.status) }}
              </template>
              <template v-slot:[`item.interest`]="{ item }">
                {{ formatLead(item.interest) }}
              </template>
              <template v-slot:[`item.segment`]="{ item }">
                {{ formatLead(item.segment) }}
              </template>
              <template v-slot:[`footer.page-text`]="items">
                Hồ sơ thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} Hồ sơ
              </template>
              <template v-slot:[`item.studentLearningMethods`]="{ item }">
                <LeadInfoDisplay :data="item.studentLearningMethods" :type="CONFIG_KEYS.STUDENT_LEARNING_METHOD" />
              </template>
              <template v-slot:[`item.studentProducts`]="{ item }">
                <LeadInfoDisplay :data="item.studentProducts" :type="CONFIG_KEYS.STUDENT_PRODUCT" />
              </template>
              <template v-slot:[`item.studentDepartments`]="{ item }">
                <LeadInfoDisplay :data="item.studentDepartments" :type="CONFIG_KEYS.STUDENT_DEPARTMENT" />
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn icon @click="() => $router.push(`/lead/${item.id}`)" class="action-hover">
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon @click="() => onDelete(item)" class="action-hover ml-2" v-if="isUserAuthorized">
                  <v-icon color="error">mdi-trash-can</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { CONFIG_KEYS, leadTableHeaders } from './helpers'
import { mapActions, mapGetters } from 'vuex'
import LeadStudentCard from '@/components/basic/card/LeadStudentCard.vue'
import LeadInfoCard from '@/components/basic/card/LeadInfoCard.vue'
import LeadCreateCard from '@/components/basic/card/LeadCreateCard.vue'
import LeadInfoDisplay from './LeadInfoDisplay.vue'
import formatLead from '@/helpers/translateLead.js'
import { formatHoChiMinhDateTime } from '@/helpers/dateTime'
import get from 'lodash-es/get'

export default {
  components: { LeadStudentCard, LeadInfoCard, LeadCreateCard, LeadInfoDisplay },
  computed: {
    ...mapGetters('auth', ['user']),
    visibleHeaders() {
      return this.headers.filter(header => {
        if (header.value === 'status') return this.selectedTab === 'all'
        return header.show
      })
    },
    isUserAuthorized() {
      const isAdmin = get(this.user, 'role.type', '') === 'manager'
      return isAdmin
    },
  },
  props: { query: Object },
  data: () => ({
    CONFIG_KEYS,
    //
    loading: false,
    headers: leadTableHeaders,
    showColumnSelector: false,
    selectedTab: 'all',
    activeTab: 0,
    Leads: [],
    appointmentsByLead: {},
    statusCount: {
      countAll: 0,
      countNoContact: 0,
      countAppointmentSet: 0,
      countProductVerified: 0,
      countSucceed: 0,
      countFailed: 0,
    },
    pagination: {
      page: 1,
      itemsPerPage: 10,
      totalItems: 0,
    },
  }),
  async mounted() {
    await this.refresh()
  },
  methods: {
    ...mapActions('lead', ['fetchLeadTableData', 'updateLead']),
    async refresh() {
      this.$loading.active = true
      this.loading = true
      try {
        const { totalItems, leads, appointmentsByLead, statusCount } = await this.fetchLeadTableData({
          selectedTab: this.selectedTab,
          query: this.query,
          pagination: this.pagination,
        })
        this.pagination.totalItems = totalItems
        this.Leads = leads
        this.appointmentsByLead = appointmentsByLead
        this.statusCount = statusCount
      } catch (error) {
        this.$alert.error('Lỗi load thông tin khách hàng')
        console.error(error)
      } finally {
        this.loading = false
        this.$loading.active = false
      }
    },
    updatePagination(val) {
      this.pagination.page = val.page
      this.pagination.itemsPerPage = val.itemsPerPage
    },
    selectTab(status) {
      this.selectedTab = status
      this.refresh()
    },
    formatActiveCodes(codes) {
      return codes.map(codeObj => codeObj.code).join(', ')
    },
    formatProducts(products) {
      return products.map(product => product.name).join(', ')
    },
    formatInCharge(inCharge) {
      return inCharge.map(sale => (sale.name ? sale.name : sale.username)).join(', ')
    },
    formatTestDate(testDate) {
      return formatHoChiMinhDateTime(testDate)
    },
    formatAppointmentDate(leadId) {
      const appointment = this.appointmentsByLead[leadId]
      return formatHoChiMinhDateTime(appointment && appointment.date)
    },
    formatLead(data) {
      return formatLead(data)
    },
    onDelete(item) {
      this.$dialog.confirm({
        title: 'Xác nhận xóa khách hàng',
        text: 'Bọn có chắc là bạn muốn xóa khách hàng này không?',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            await this.updateLead({ id: item.id, isArchived: 'true' })
            this.$alert.success('Xóa khách hàng thành công')
            this.refresh()
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },
  watch: {
    'pagination.page'() {
      this.refresh()
    },
    'pagination.itemsPerPage'() {
      this.refresh()
    },
    query(newQuery, oldQuery) {
      if (newQuery !== oldQuery) {
        this.refresh()
      }
    },
    selectedTab(newVal) {
      const statusHeader = this.headers.find(header => header.value === 'status')
      if (statusHeader) {
        statusHeader.show = newVal === 'all'
      }
    },
  },
}
/* eslint-enable no-unused-vars */
</script>
<style>
.clickable-text {
  color: blue;
  cursor: pointer;
}
.scrollable-menu {
  max-height: 300px;
  overflow-y: auto;
}
.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
.max-width-description {
  max-width: 200px;
}
.active {
  opacity: 1 !important;
  color: #0d47a1 !important;
  background-color: #ffffff !important;
  border: 1px solid lightgrey;
}
.v-tabs-slider {
  color: #0d47a1 !important;
  caret-color: #0d47a1 !important;
}
</style>
